import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const Container = Box.withConfig({
  flexGrow: 1,
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
  paddingX: {
    base: '$16',
  },
});

export const ProductTitle = withTypography({
  accessible: true,
  m: '$0',
  numberOfLines: 1,
  variant: 'headerOne',
  fontSize: 18,
  lineHeight: 25,
});
